<template>
    <div :class="{ 'button-book-container': true, 'lx-glow': !disabled }">
        <b-button
            class="button-book w-100"
            size="lg"
            type="submit"
            :variant="variant"
            :disabled="disabled"
        >
            Book Now
        </b-button>
    </div>
</template>

<script>
    export default {
        name: 'ButtonBook',
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            variant: {
                type: String,
                default: "light",
            }
        },
    };
</script>

<style lang="scss" scoped>
    .button-book-container {
        position: relative;
        z-index: 1;
    }

    .lx-glow::before {
        content: '';
        position: absolute;
        left: -2px;
        top: -2px;
        background: linear-gradient(
            -45deg,
            #007bff,
            #007bff,
            #007bff,
            #007bff,
            #007bff
        );
        background-size: 400%;
        width: calc(100% + 5px);
        height: calc(100% + 5px);
        z-index: -1;
        animation: change 40s linear infinite;
    }

    @keyframes change {
        0% {
            background-position: 0 0;
        }

        50% {
            background-position: 400% 0;
        }

        100% {
            background-position: 0 0;
        }
    }

    .lx-glow::before {
        filter: blur(5px);
        opacity: 0.75;
    }
</style>
